import { reportsService } from "./reports";

export const freeServices = {
  reports: reportsService,
};

export * from "./reports";
